import React from 'react'
import { Box, Container, Divider, Link, } from '@mui/material'
import Copyright from '../submodules/Copyright';
import SocialMedia from '../modules/SocialMedia';
import Accessibility from '../submodules/Accessibility';
import PersonalArchitectLogoHorizontal from '../../assets/svg/logos/primary/personal-architect-horizontal.svg'

const Footer = (props) => {

  return (
    <Box>
      <Divider sx={{my: 3,}}/>
      <Container maxWidth="xl">
        <Box sx={{alignItems: "center", justifyContent: "center", display: "flex",}}>
          <Link href="https://www.personalarch.com/" target="_blank" sx={{alignItems: "center", display: "flex", borderBottom: '1px solid transparent', transition: '.05s ease all', '&:hover': { borderBottom: '1px solid #b71c1c', transition: '.05s ease all', }}}>
            <Box
              alt="Personal Architect Logo"
              component="img"
              loading="lazy"
              src={PersonalArchitectLogoHorizontal}
              sx={{height: 36.15, width: 220,}}
            />
          </Link>
        </Box>
        <Box sx={{display: "flex", justifyContent: "center", mt:1,}}>
          <SocialMedia flexDirection="row" />
        </Box>
      </Container>
      <Box sx={{alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "center", my: 1}}>
        <Accessibility />
      </Box>
      <Copyright />
    </Box>
  )
}

export default Footer